import React, { useCallback, useEffect } from 'react';
import { Button } from '@mui/material';
import { Link as LinkIcon } from '@mui/icons-material';
import { LiveShareDialog } from './LiveShareDialog';
import { useLiveShare } from '../../hooks/useLiveShare';
import { useCurrentThreadContext } from '../../contexts/CurrentThreadContext';

type LiveShareLinkProps = {
  hidden?: boolean;
};

export function LiveShareLink({ hidden = false }: LiveShareLinkProps) {
  const liveShare = useLiveShare();
  const { setLiveShareBroadcaster } = useCurrentThreadContext();

  const handleCopy = useCallback(() => {
    if (!liveShare.link) return;
    navigator.clipboard?.writeText(liveShare.link).catch(() => undefined);
  }, [liveShare.link]);

  useEffect(() => {
    setLiveShareBroadcaster(liveShare.broadcast);
    return () => setLiveShareBroadcaster(null);
  }, [liveShare.broadcast, setLiveShareBroadcaster]);

  if (hidden) {
    return (
      <LiveShareDialog
        open={liveShare.open}
        onClose={liveShare.closeDialog}
        link={liveShare.link}
        active={liveShare.active}
        onCopy={handleCopy}
        onStop={liveShare.stop}
      />
    );
  }

  return (
    <>
      <Button
        variant="outlined"
        size="small"
        startIcon={<LinkIcon />}
        onClick={liveShare.openDialog}
        sx={{ textTransform: 'none' }}
      >
        Live Share
      </Button>
      <LiveShareDialog
        open={liveShare.open}
        onClose={liveShare.closeDialog}
        link={liveShare.link}
        active={liveShare.active}
        onCopy={handleCopy}
        onStop={liveShare.stop}
      />
    </>
  );
}
